var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-table"},[(!_vm.tableData || !_vm.tableData.length)?_c('NoUserItemMessage'):_vm._e(),_vm._l((_vm.tableData),function(user){return _c('UserItem',{key:user.id,attrs:{"user":user}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }